import PropTypes from 'prop-types';
import { optionPropTypes } from '@prop-types/option';

export const orderOptionPropTypes = PropTypes.shape({
  option: optionPropTypes.isRequired,
  quantity: PropTypes.number.isRequired,
});
